import "./SubscriptionCard.css";
import { toastify } from "../../../../helpers/toast/toastify";
import { updateUser } from "../../../../redux/users/usersSlice";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Arrow from "../../../../assets/images/rightAnglePath.svg";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import FloatingTextFiled from "../../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import InfoPopup from "../../CommonComponents/InfoPopup/InfoPopup";
import TierBoxes from "./TierBoxes/TierBoxes";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import cross from "../../../../assets/images/cross.svg";
import vipBellPng from "../../../../assets/images/vipBellPng.png";
import { Button, Modal, Row } from "react-bootstrap";

const options = [
  {
    label: "No trial",
    value: "0",
  },
  {
    label: "7 days ",
    value: "7",
  },
  {
    label: "14 days",
    value: "14",
  },
  {
    label: "1 Month",
    value: "30",
  },
];

const DELETED_IDS_KEY = "deletedTierIds";
const loadDeletedIds = () => {
  try { return new Set(JSON.parse(localStorage.getItem(DELETED_IDS_KEY) || "[]")); }
  catch { return new Set(); }
};
const saveDeletedIds = (ids) => {
  try { localStorage.setItem(DELETED_IDS_KEY, JSON.stringify([...ids])); } catch {}
};

const SubscriptionCard = () => {
  const [editMode, setEditMode] = useState(false);
  const [editOldData, setEditOldData] = useState({});
  const [showModal, setShowModal] = useState({ apiObject: {}, show: false });
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(false);

  const { user } = useSelector((state) => state.user);
  const api = useApi();
  const dispatch = useDispatch();

  const monthlyInputRef = useRef(null);

  useEffect(() => {
    if (editMode && monthlyInputRef.current) {
      monthlyInputRef.current.focus();
    }
  }, [editMode]);

  const [formData, setFormData] = useState({
    monthlyfee: "",
    tradingCapital: "",
    trialPeriodDays: "",
    trialPeriodLabel: "Select Trial",
    yearlyfee: "",
    index: "",
    minimumFunding: "",
  });

  const [formErrors, setFormErrors] = useState({
    monthlyfee: false,
    tradingCapital: false,
    yearlyfee: false,
    minimumFunding: false,
  });

  const [visibleDropdowns, setVisibleDropdowns] = useState({});
  const [selectTrialDropdown, setSelectTrialDropdown] = useState(false);
  const [locallyDeletedIds, setLocallyDeletedIds] = useState(loadDeletedIds);
  const [permanentDeleteTier, setPermanentDeleteTier] = useState(null);

  const handleDropdownToggle = (index) => {
    setVisibleDropdowns((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const handleOptionClick = (option, index, tier) => {
    if (option === "Edit") {
      setEditMode(true);
      const trialPeriodOption = options.find(
        (option) => option.value === tier?.trialPeriodDays
      );

      const oldSubscription = {
        monthlyfee: tier?.monthlyfee,
        yearlyfee: tier?.yearlyfee,
        tradingCapital: tier?.tradingCapital,
        trialPeriodDays: tier?.trialPeriodDays,
        trialPeriodLabel: trialPeriodOption ? trialPeriodOption.label : "0",
        index: tier?.index,
        minimumFunding: tier?.minimumFunding,
      };
      setEditOldData({ ...oldSubscription, oldSubscriptionId: tier?._id });

      setFormData(oldSubscription);
    } else if (option === "Delete") {
      const activeTiersCount = tiers.filter((t) => t.isActive).length;
      if (!tier.isActive) {
        // Hidden tier — show permanent delete confirmation
        setPermanentDeleteTier(tier);
      } else if (activeTiersCount === 1) {
        toastify("You cannot delete the last tier", "error");
      } else {
        setShowModal({ show: true, apiObject: tier });
      }
    } else if (option === "Reactivate") {
      reactivateSubscription(tier);
    }

    setVisibleDropdowns((prevState) => ({
      ...prevState,
      [index]: false,
    }));
  };

  const handleInputChange = (event, field) => {
    const value = event.target.value;

    const patterns = {
      monthlyfee: /^[0-9]*\.?[0-9]+$/,
      tradingCapital: /^[A-Za-z0-9]*$/,
      yearlyfee: /^[0-9]*\.?[0-9]+$/,
      minimumFunding: /^[0-9]*\.?[0-9]+$/,
    };

    setFormErrors((prev) => ({
      ...prev,
      [field]: false,
    }));

    const pattern = patterns[field];

    if (pattern) {
      if (value === "" || pattern.test(value))
        setFormData({
          ...formData,
          [field]: value,
        });
    } else
      setFormData({
        ...formData,
        [field]: value,
      });
  };

  const handleTier = async () => {
    const activeTiersCount = tiers.filter((t) => t.isActive).length;
    if (activeTiersCount >= 5 && !editMode) {
      toastify("You've added maximum amount of tier.", "error");
      setFormData({
        monthlyfee: "",
        yearlyfee: "",
        tradingCapital: "",
        trialPeriodDays: "",
        trialPeriodLabel: "Select Trial",
        minimumFunding: "",
      });
      return;
    }

    if (checkFormValidation()) {
      setLoading(true);
      if (editMode) {
        if (
          editOldData?.monthlyfee === formData?.monthlyfee &&
          editOldData?.tradingCapital === formData?.tradingCapital &&
          editOldData?.trialPeriodDays === formData?.trialPeriodDays &&
          editOldData?.yearlyfee === formData?.yearlyfee &&
          editOldData?.minimumFunding === formData?.minimumFunding
        ) {
          toastify("Please Edit some thing to update your subscription");
        } else {
          const response = await api("post", "copyTrade/editSubscription", {
            subscription: formData,
            oldSubscriptionId: editOldData?.oldSubscriptionId,
          });
          if (response?.status) {
            fetchUserData();
            setEditMode(false);
            setFormData({
              monthlyfee: "",
              yearlyfee: "",
              tradingCapital: "",
              trialPeriodDays: "",
              trialPeriodLabel: "Select Trial",
              minimumFunding: "",
            });
            setFormErrors({
              monthlyfee: false,
              yearlyfee: false,
              tradingCapital: false,
              minimumFunding: false,
            });
            toastify("Subscription updated successfully", "success");
          }
        }
      } else {
        formData.index = tiers.filter((t) => t.isActive).length + 1;
        const response = await api("post", "copyTrade/submitSubscription", {
          subscription: formData,
        });
        if (response?.status) {
          fetchUserData();
          setFormData({
            monthlyfee: "",
            yearlyfee: "",
            tradingCapital: "",
            trialPeriodDays: "",
            trialPeriodLabel: "Select Trial",
            minimumFunding: "",
          });
          setFormErrors({
            monthlyfee: false,
            yearlyfee: false,
            tradingCapital: false,
            minimumFunding: false,
          });
          toastify("Subscription added successfully", "success");
        }
      }
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    const myResponse = await api("get", "users/index");
    if (myResponse) {
      dispatch(updateUser(myResponse?.data?.user));
    }
  };

  useEffect(() => {
    const allSubscriptions = user?.leaderCommunity?.subscription;
    if (!allSubscriptions) return;

    const activeSubscription = allSubscriptions
      .filter((tier) => tier.isActive)
      .sort((a, b) => a.index - b.index);

    setFormData((prevState) => ({
      ...prevState,
      trialPeriodDays: activeSubscription.at(-1)?.trialPeriodDays || "",
      trialPeriodLabel:
        options.find(
          (option) =>
            option.value === activeSubscription.at(-1)?.trialPeriodDays
        )?.label || "",
    }));

    const allSorted = [...allSubscriptions]
      .filter((tier) => !tier.isDeleted && !locallyDeletedIds.has(tier._id))
      .sort((a, b) => {
        if (a.isActive !== b.isActive) return a.isActive ? -1 : 1;
        return a.index - b.index;
      });
    setTiers(allSorted);
  }, [user, locallyDeletedIds]);

  const checkFormValidation = () => {
    let maxCapital = formData?.tradingCapital?.trim() || "";
    const monthlyfee = formData?.monthlyfee?.trim() || "";
    const trialPeriodDays = formData?.trialPeriodDays || "";
    const yearlyfee = formData?.yearlyfee?.trim() || "";
    const minimumFunding = formData?.minimumFunding?.trim() || "";

    const errors = {};
    let formValid = true;

    if (!monthlyfee) {
      toastify("Please enter a monthly price");
      errors.monthlyfee = true;
      formValid = false;
    } else {
      const monthlyNum = parseFloat(monthlyfee);
      if (isNaN(monthlyNum) || monthlyNum <= 0 || monthlyNum >= 10000) {
        toastify(
          "Please enter a valid positive number (1-9999) for monthly price"
        );
        errors.monthlyfee = true;
        formValid = false;
      } else {
        errors.monthlyfee = false;
      }
    }

    if (!yearlyfee) {
      toastify("Please enter a yearly price");
      errors.yearlyfee = true;
      formValid = false;
    } else {
      const yearlyNum = parseFloat(yearlyfee);
      if (isNaN(yearlyNum) || yearlyNum <= 0 || yearlyNum >= 10000) {
        toastify(
          "Please enter a valid positive number (1-9999) for yearly price"
        );
        errors.yearlyfee = true;
        formValid = false;
      } else {
        errors.yearlyfee = false;
      }
    }

    if (!maxCapital) {
      // toastify("Please enter a trading capital");
      // errors.tradingCapital = true;
      // formValid = false;
      maxCapital = "unlimited";
    } else if (maxCapital.toUpperCase() === "UNLIMITED") {
      errors.tradingCapital = false;
    } else {
      const capitalNum = parseFloat(maxCapital);
      if (isNaN(capitalNum) || capitalNum <= 0 || capitalNum >= 1000000) {
        toastify(
          "Please enter a valid positive number (1-999999) or 'UNLIMITED' for trading capital"
        );
        errors.tradingCapital = true;
        formValid = false;
      } else {
        errors.tradingCapital = false;
      }
    }

    if (!minimumFunding) {
      toastify("Please enter a minimum trading capital");
      errors.minimumFunding = true;
      formValid = false;
    } else {
      const minFundingNum = parseFloat(minimumFunding);
      if (
        isNaN(minFundingNum) ||
        minFundingNum <= 0 ||
        minFundingNum >= 1000000
      ) {
        toastify(
          "Please enter a valid positive number (1-999999) for minimum trading capital"
        );
        errors.minimumFunding = true;
        formValid = false;
      } else {
        errors.minimumFunding = false;
      }
    }

    if (!trialPeriodDays) {
      toastify("Please select a free trial period");
      formValid = false;
    }

    setFormErrors((prev) => ({
      ...prev,
      ...errors,
    }));

    return formValid;
  };

  const deleteSubscription = async (action) => {
    const deletedId = showModal?.apiObject?._id;

    const response = await api("post", "copyTrade/deleteSubscription", {
      subscriptionId: deletedId,
      action,
      delete: action !== "hide",
    });

    setShowModal({ apiObject: {}, show: false });

    if (response?.status) {
      if (action === "deleteAll" && deletedId) {
        setLocallyDeletedIds((prev) => {
          const next = new Set([...prev, deletedId]);
          saveDeletedIds(next);
          return next;
        });
      }
      fetchUserData();
      toastify(
        action === "hide"
          ? "Subscription hidden successfully"
          : "Subscription deleted successfully",
        "success"
      );
    }
  };

  const deleteHiddenTier = async (tier) => {
    const response = await api("post", "copyTrade/deleteSubscription", {
      subscriptionId: tier._id,
      action: "deleteAll",
      delete: true,
    });

    if (response?.status) {
      setLocallyDeletedIds((prev) => {
        const next = new Set([...prev, tier._id]);
        saveDeletedIds(next);
        return next;
      });
      fetchUserData();
      toastify("Subscription deleted successfully", "success");
    }
  };

  const reactivateSubscription = async (tier) => {
    const response = await api("post", "copyTrade/activateSubscription", {
      subscriptionId: tier._id,
    });
    if (response?.status) {
      const updatedSubscriptions = user?.leaderCommunity?.subscription?.map((s) =>
        s._id === tier._id ? { ...s, isActive: true } : s
      );
      dispatch(updateUser({
        ...user,
        leaderCommunity: {
          ...user?.leaderCommunity,
          subscription: updatedSubscriptions,
        },
      }));
      toastify("Subscription activated successfully", "success");
    } else {
      toastify(response?.message || "Failed to activate", "error");
    }
  };

  const selectTierRef = useRef(null);
  const tierRef = useRef(null);

  const handleClickOutsideDropdown = (e) => {
    if (selectTierRef.current && !selectTierRef.current.contains(e.target))
      setSelectTrialDropdown(false);

    if (tierRef.current && !tierRef.current.contains(e.target))
      setVisibleDropdowns({});
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideDropdown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    };
  }, []);

  return (
    <>
      <div className="subscriptionBox">
        <div className="row">
          <div className="col-lg-6 col-md-7 col-12">
            <div className="titleWrapper">
              <p className="title">Subscription</p>
              <InfoPopup
                contentItems={[
                  { text: "Subscription Tier", type: "heading" },
                  {
                    text: " Min. 1 subscription tier is needed for your copy trading to work. We'll add $15 to your subscription fee. Maximum trading capital is the amount of capital subscribers  will be copy trading with. This feature makes it possible for you to charge more for subscribers with more capital. Leave it blank for unlimited trading capital.",
                    type: "paragraph",
                  },
                ]}
              />
            </div>
            <div className="subTitle">
              Define your subscription plan(s)
            </div>
          </div>

          <div className="col-lg-6 col-md-5 col-12"></div>
        </div>

        <div className="grid-row mb-10px align-items-start">
          {/* Monthly price input */}
          <div className="grid-col">
            <div className="">
              <FloatingTextFiled
                ref={monthlyInputRef}
                className={` ${
                  formErrors.monthlyfee && "invalid"
                }`}
                forLabel="monthly-price"
                id="monthly-price"
                label="Monthly price ($)"
                onChange={(e) => handleInputChange(e, "monthlyfee")}
                placeholder="Monthly price ($)"
                value={formData.monthlyfee}
                disabled={editMode}
              />
            </div>
          </div>

          {/* Yearly price input */}
          <div className="grid-col">
            <div className="">
              <FloatingTextFiled
                className={` mx-auto ${
                  formErrors.yearlyfee && "invalid"
                }`}
                forLabel="yearly-price"
                id="yearly-price"
                label="Yearly price ($)"
                onChange={(e) => handleInputChange(e, "yearlyfee")}
                placeholder="Yearly price ($)"
                value={formData.yearlyfee}
                disabled={editMode}
              />
            </div>
          </div>

          {/* Maximum trading capital input */}
          <div className="grid-col">
            <div className="">
              <FloatingTextFiled
                className={` mx-auto ${
                  formErrors.tradingCapital && "invalid"
                }`}
                forLabel="maximum-trading-capital"
                id="maximum-trading-capital"
                label="Max. Trading Capital"
                onChange={(e) => handleInputChange(e, "tradingCapital")}
                value={formData.tradingCapital}
              />
              {/* <p className="maxTradeText">Enter $ value (blank = unlimited)</p> */}
              <p className="maxTradeText">Leave blank for unlimited</p>
            </div>
          </div>

          {/* Minimum trading capital input */}
          <div className="grid-col">
            <div className="">
              <FloatingTextFiled
                className={` ${
                  formErrors.minimumFunding && "invalid"
                }`}
                forLabel="minimum-trading-capital"
                id="minimum-trading-capital"
                label="Min. Trading Capital"
                onChange={(e) => handleInputChange(e, "minimumFunding")}
                value={formData.minimumFunding}
              />
            </div>
          </div>
        </div>

        <div className="grid-row justify-content-end mb-d">
          <p className="inputBottomText mobileDisplay gap-1">
            Members are billed{" "}
            <span className="BoldText">
              ${formData.monthlyfee ? +formData.monthlyfee + 15 : 0}
            </span>{" "}
            monthly /{" "}
            <span className="BoldText">
              ${formData.yearlyfee ? +formData.yearlyfee + 180 : 0}
            </span>{" "}
            yearly
          </p>
          <div className="grid-col">
            <div className="">
              <BubbleSvgButton
                onClick={handleTier}
                text={editMode ? "Update tier" : "Add tier"}
                type="button"
                variant="green"
                disabled={loading}
                isLoading={loading}
                containerStyling={{
                  justifyContent: "center",
                }}
              />
            </div>
          </div>
        </div>

        <div className="row align-items-center ">
          <div className="col-lg-6 col-md-6 col-12">
            <p className="inputBottomText desktopOnly gap-1">
              Members are billed{" "}
              <span className="BoldText">
                ${formData.monthlyfee ? +formData.monthlyfee + 15 : 0}
              </span>{" "}
              monthly /{" "}
              <span className="BoldText">
                ${formData.yearlyfee ? +formData.yearlyfee + 180 : 0}
              </span>{" "}
              yearly
            </p>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div
              className="select-trial-dropdown-container"
              ref={selectTierRef}
            >
              <div className="d-flex gap-2">
                <p className="fs-14 fw-medium">Select trial :</p>
                <div className="select-trial-dropdown-container-inner">
                  <button
                    className="select-trial-button"
                    onClick={() => {
                      setSelectTrialDropdown((prevState) => !prevState);
                    }}
                  >
                    <img
                      alt=""
                      className="dropdown-arrow"
                      src={dropdownAngle}
                      style={{
                        transform: selectTrialDropdown
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                      }}
                    />
                    <span style={{
                      whiteSpace: 'nowrap'
                    }}>{formData.trialPeriodLabel}</span>
                  </button>
                  <span className="infoSpan">
                    <InfoPopup
                      contentItems={[
                        { text: "Free trial", type: "heading" },
                        {
                          text: "We recommend you offer some kind of trial. The subscribers won't be charged if subscription is cancelled before end of trial.",
                          type: "paragraph",
                        },
                      ]}
                    />
                  </span>
                </div>
              </div>
              {selectTrialDropdown && (
                <div className="custom-dropdown">
                  <ul>
                    {options.map((option) => (
                      <li key={option.value}>
                        <button
                          onClick={() => {
                            setFormData({
                              ...formData,
                              trialPeriodDays: option.value,
                              trialPeriodLabel: option.label,
                            });
                            setSelectTrialDropdown(false);
                          }}
                        >
                          {option.label}
                          <img src={Arrow} alt="Arrow Icon" />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <TierBoxes
        handleDropdownToggle={handleDropdownToggle}
        handleOptionClick={handleOptionClick}
        tierRef={tierRef}
        tiers={tiers}
        visibleDropdowns={visibleDropdowns}
      />

      {showModal?.show && (
        <DeletePopUp
          setShowModal={setShowModal}
          deleteSubscription={deleteSubscription}
        />
      )}

      {permanentDeleteTier && (
        <PermanentDeletePopUp
          onConfirm={() => { deleteHiddenTier(permanentDeleteTier); setPermanentDeleteTier(null); }}
          onClose={() => setPermanentDeleteTier(null)}
        />
      )}
    </>
  );
};

const DeletePopUp = ({ setShowModal, deleteSubscription }) => {
  return (
    <div className="deleteModal">
      <Modal
        backdrop="false"
        id="deleteModal"
        onHide={() => {
          setShowModal({ apiObject: {}, show: false });
        }}
        show={true}
      >
        <Modal.Body>
          <div className="modalContent">
            <Button
              className="closeBtn"
              onClick={() => {
                setShowModal({ apiObject: {}, show: false });
              }}
            >
              <img alt="Close Modal" src={cross} />
            </Button>
            <div
              className="regBox"
              style={{ padding: "42px 25px 0px 5px" }}
            >
              <div className="img-box">
                <img alt="Warning Bell" src={vipBellPng} />
              </div>
              <div className="content-box">
                <p>
                  <span>Delete this subscription tier?</span>
                  <br />
                  Choose how to handle existing subscribers.
                </p>
              </div>
            </div>
          </div>
          <div className="deleteOptions">
            <div className="deleteOption" onClick={() => deleteSubscription("hide")}>
              <p className="deleteOptionTitle">Hide from new users</p>
              <p className="deleteOptionDesc">Existing members keep their access. New subscribers won't see this tier.</p>
            </div>
            <div className="deleteOption danger" onClick={() => deleteSubscription("deleteAll")}>
              <p className="deleteOptionTitle">Delete &amp; remove all members</p>
              <p className="deleteOptionDesc">All current subscribers of this tier will be unsubscribed.</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const PermanentDeletePopUp = ({ onConfirm, onClose }) => (
  <div className="deleteModal">
    <Modal backdrop="false" id="permanentDeleteModal" onHide={onClose} show={true}>
      <Modal.Body>
        <div className="modalContent">
          <Button className="closeBtn" onClick={onClose}>
            <img alt="Close Modal" src={cross} />
          </Button>
          <div className="regBox" style={{ padding: "42px 25px 0px 5px" }}>
            <div className="img-box"><img alt="Warning" src={vipBellPng} /></div>
            <div className="content-box">
              <p>
                <span>Permanently delete this tier?</span>
                <br />
                This action cannot be undone. All members on this tier will lose access permanently.
              </p>
            </div>
          </div>
        </div>
        <div className="deleteOptions">
          <div className="deleteOption danger" onClick={onConfirm}>
            <p className="deleteOptionTitle">Yes, delete permanently</p>
            <p className="deleteOptionDesc">Members will lose access and this tier cannot be recovered.</p>
          </div>
          <div className="deleteOption" onClick={onClose}>
            <p className="deleteOptionTitle">Cancel</p>
            <p className="deleteOptionDesc">Keep this tier as is.</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </div>
);

export default SubscriptionCard;
